module.exports = __webpack_public_path__ + "img/202402_03.b3a7b889.jpg";